import React from 'react'
import {Form} from 'react-bootstrap'
import { useFormContext, Controller  } from 'react-hook-form'

const InputTextField = ({name, label}) => {

    const {control} = useFormContext();

  return (
    <div>
      <Controller
        control={control}
        name={name}
        defaultValue=""
        rules={{ required: true }}
        render={({ field: { onChange, value } }) => (
            <Form.Group className="mb-3" fullWidth
            label={label}
            required>
                <Form.Label>{label}</Form.Label>
                <Form.Control type="text" value={value} onChange={onChange}/>
            </Form.Group>
        )}
      />
    </div>
  )
}

<Form.Text
                
            />

export default InputTextField
